if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      BSS_B2B.cart.fixer(
              JSON.parse($("#bss-b2b-store-data").html()),
              null,
              false
            );
    }, 3000)
  }
}